import React, { useState } from 'react';
import { useCustomContext } from '../CustomComponents/CustomComponents';
import { AuthenticationDetails, CognitoUser } from 'amazon-cognito-identity-js';
import UserPool from '../../UserPool';
import { insertLog } from '../Logs/InsertLog';

const UpdatePasswordLogic = () => {
    const [isLoading, setLoading] = useState(false);
    const [showOldPassword, setShowOldPassword] = useState(false);
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [errorMessages, setErrorMessages] = useState({});
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const { showToast, hud, stopHudRotation, showAlert } = useCustomContext();
    const email = localStorage.getItem("email");
    const userName = email?.split('@')[0];
    // Regex patterns for password validation
    const passwordRegex =
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\^$*.\[\]{}()?"!@#%&\/\\,><':;|_~`+= -])[A-Za-z\d\^$*.\[\]{}()?"!@#%&\/\\,><':;|_~`+= -]{8,}$/;

    // Validate old password function
    const validateOldPassword = () => {
        let errors = {};

        if (!oldPassword) {
            errors.oldPassword = "Old password is required";
        } else if (oldPassword !== oldPassword.trim()) {
            errors.oldPassword =
                "Password cannot start or end with a space";
        } else if (/\s{2,}/.test(oldPassword)) {
            errors.oldPassword =
                "Password cannot contain multiple consecutive spaces";
        } else if (!passwordRegex.test(oldPassword)) {
            errors.oldPassword =
                "Password must be at least 8 characters and include uppercase, lowercase, number, and special character";
        }

        return errors;
    };

    // Validate new password function
    const validateNewPassword = () => {
        let errors = {};

        if (!newPassword) {
            errors.newPassword = "New password is required";
        } else if (newPassword !== newPassword.trim()) {
            errors.newPassword =
                "Password cannot start or end with a space";
        } else if (/\s{2,}/.test(newPassword)) {
            errors.newPassword =
                "Password cannot contain multiple consecutive spaces";
        } else if (!passwordRegex.test(newPassword)) {
            errors.newPassword =
                "Password must be at least 8 characters and include uppercase, lowercase, number, and special character";
        } else if (newPassword === oldPassword) {
            errors.newPassword =
                "New password must be different from old password";
        }

        if (!confirmPassword) {
            errors.confirmPassword =
                "Confirm password is required";
        } else if (newPassword !== confirmPassword) {
            errors.confirmPassword =
                "Passwords do not match";
        }

        return errors;
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        // Validate passwords
        const oldPasswordErrors = validateOldPassword();
        const newPasswordErrors = validateNewPassword();
        const errors = { ...oldPasswordErrors, ...newPasswordErrors };

        if (Object.keys(errors).length > 0) {
            setErrorMessages(errors);
            stopHudRotation();
            return;
        }

        if (!email) {
            showToast({ message: "email not found in local storage" });
            setLoading(false);
            insertLog(
                `${userName || 'User'} failed to update password`,
                0,
                email || '',
                hud,
                stopHudRotation,
                showAlert,
                '',
                'UPDATE',
                'CognitoUser_ChangePassword',
                'FAILED',
                'Email not found'
            );
            return;
        }
        const userData = {
            Username: email,
            Pool: UserPool,
        };


        const cognitoUser = new CognitoUser(userData);

        // Authenticate user
        const authenticationDetails = new AuthenticationDetails({
            Username: email,
            Password: oldPassword.trim(),
        });

        cognitoUser.authenticateUser(authenticationDetails, {
            onSuccess: () => {
                setLoading(true);
                // Change password after authentication
                cognitoUser.changePassword(oldPassword.trim(), newPassword.trim(), (err, result) => {
                    setLoading(false);
                    stopHudRotation();

                    if (err) {
                        insertLog(
                            `${userName} failed to update their password`,
                            0,
                            email,
                            hud,
                            stopHudRotation,
                            showAlert,
                            '',
                            'UPDATE',
                            'CognitoUser_ChangePassword',
                            'FAILED',
                            err.message
                        );
                        showToast({ message: `Error changing password: ${err.message}` });
                        return;
                    }

                    insertLog(
                        `${userName} updated their password`,
                        0,
                        email,
                        hud,
                        stopHudRotation,
                        showAlert,
                        '',
                        'UPDATE',
                        'CognitoUser_ChangePassword',
                        'SUCCESS',
                        ''
                    );

                    showToast({ message: "Password changed successfully!" });
                    localStorage.removeItem("rememberedPassword");
                    setOldPassword("");
                    setNewPassword("");
                    setConfirmPassword("");
                    setErrorMessages({});
                });

            },
            onFailure: (err) => {
                setLoading(false);
                stopHudRotation();
                setErrorMessages({});
                insertLog(
                    `${userName} failed to authenticate while changing password`,
                    0,
                    email,
                    hud,
                    stopHudRotation,
                    showAlert,
                    '',
                    'UPDATE',
                    'CognitoUser_ChangePassword',
                    'FAILED',
                    err.message
                );
                showToast({ message: `Authentication failed: ${err.message}` });
            },
        });
    };

    const handleCancel = () => {
        setNewPassword('');
        setOldPassword('');
        setConfirmPassword('');
        setErrorMessages({});
    };
    return (
        {
            isLoading,
            showOldPassword,
            setShowOldPassword,
            showNewPassword,
            setShowNewPassword,
            showConfirmPassword,
            setShowConfirmPassword,
            handleCancel,
            handleSubmit,
            errorMessages,
            hud, setOldPassword,
            oldPassword,
            newPassword, setNewPassword,
            confirmPassword, setConfirmPassword
        }
    )
}

export default UpdatePasswordLogic